import { observable, action } from 'mobx'
import Cookie from 'js-cookie'
import isNil from 'lodash/isNil'
import { StoreExt } from 'util/reactExt'
import ENVCONFIG from '@env'

export class LoginStore extends StoreExt {
  @observable isLogin: boolean = !isNil(Cookie.get('AUTHOR_TOKEN'))

  constructor() {
    super()
  }

  @action
  login = async (account, password) => {
    try {
      const res = await this.api.user.login({
        account,
        password,
      })

      Cookie.set('LOGININFO', JSON.stringify(res))
      this.changeLoginStatus(true)
      this.$message.success('登陆成功！')
    } catch (e) {
      throw new Error(e)
    }
  }

  @action
  logout = async () => {
    try {
      await this.api.user.logout()
    } catch (e) {
      throw new Error(e)
    }

    let domain = 'jingzhuan.cn'

    if (process.env.APP_ENV === 'qa') {
      domain = 'atido.com'
    }

    Cookie.remove('AUTHOR_TOKEN', {
      domain,
    })
    Cookie.remove('AUTHOR_PROJECT', {
      domain,
    })
    this.$message.success('退出登陆成功！')
    setTimeout(() => {
      this.changeLoginStatus(false)
      location.href = ENVCONFIG.loginPage
    })
  }

  @action
  changeLoginStatus = (islogin: boolean) => {
    this.isLogin = islogin
  }
}

export default new LoginStore()
